export enum TipoDeAcesso {
  ADMIN = 'admin',
  STUDENT = 'aluno',
}
